import React, { useState, useEffect } from "react";
import { fetchAds } from "../services/api";
import { useSwipeable } from "react-swipeable";
import "../styles.css";

const AdBlock = ({ userLocation }) => {
    const [ads, setAds] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [hovered, setHovered] = useState(false);

    useEffect(() => {
        const loadAds = async () => {
            const adData = await fetchAds('Durban');
            const sortedAds = adData.sort((a, b) => a.priority - b.priority);
            setAds(sortedAds);
            //console.log("Retrieved ads: " + JSON.stringify(sortedAds, null, 2));
        };
        loadAds();
    }, [userLocation]);

    useEffect(() => {
        if (hovered || ads.length < 2) return;
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 2) % ads.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [hovered, ads.length]);

    const nextAds = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 2) % ads.length);
    };

    const prevAds = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 2 + ads.length) % ads.length);
    };

    const handlers = useSwipeable({
        onSwipedLeft: nextAds,
        onSwipedRight: prevAds,
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
    });

    return (
        <div className="ad-block" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} {...handlers}>
            <div className="ads-container" style={{ transform: `translateX(-${currentIndex * 50}%)` }}>
                {ads.map((ad, index) => (
                    <div key={index} className="ad">
                        <a href={ad.targetUrl} target="_blank" rel="noopener noreferrer">
                            <img src={ad.imageUrl} alt="Advertisement" />
                        </a>
                    </div>
                ))}
            </div>
            <div className="ad-dots">
                {ads.map((_, index) => (
                    <div key={index} className={`dot ${index === currentIndex ? "active" : ""}`} onClick={() => setCurrentIndex(index)} />
                ))}
            </div>
        </div>
    );
};

export default AdBlock;
